export const ADD_CAKE_MESSAGE_STATIC_ASSETS = {
    CAKE_ICON: "portal/static-assets/hcms/mothers_day/25/add message cake icon.png",
};
export const ADD_CAKE_MESSAGE_PILL_TEXT = "Add message on cake";
